/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { KTIcon, useDebounce } from '../../../../../../_metronic/helpers'
import { initialQueryState } from '../../../../../../_metronic/helpers/crud-helper/custom-models'
import { useQueryRequest } from '../../core/QueryRequestProvider'

import { useNavigate } from 'react-router-dom'

const ProductsListSearchComponent = (props) => {
    const { updateState, state } = useQueryRequest()
    const [searchTerm, setSearchTerm] = useState<string>((state.search === undefined) ? '' : state.search)
    const debouncedSearchTerm = useDebounce(searchTerm, 500)
    const navigate = useNavigate()

    const HandleChange = (e) => {
        setSearchTerm(e.target.value)
    }
    useEffect(
        () => {
            if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
                updateState({ search: debouncedSearchTerm.trim(), ...initialQueryState })
                props?.getData && props?.getData(debouncedSearchTerm.trim())
                props?.getDataTotalProducts && props?.getDataTotalProducts(debouncedSearchTerm.trim())
                props?.getDatatotalbuyers && props?.getDatatotalbuyers(debouncedSearchTerm.trim())
                props?.getDataTotaladmins && props?.getDataTotaladmins(debouncedSearchTerm.trim())
                props?.getDatarisk_products && props?.getDatarisk_products(debouncedSearchTerm.trim())
                props?.getDatabonus_products && props?.getDatabonus_products(debouncedSearchTerm.trim())
            }
        },
        [debouncedSearchTerm]
    )

    const location = window.location.pathname;
    const isDashboard = location.includes('/dashboard/');
    return (
        <div className='d-flex align-items-center justify-content-between position-relative my-1 w-100'>
            <div className='d-flex align-items-center position-relative'>
                <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                <input
                    type='search'
                    data-kt-product-table-filter='search'
                    className='form-control form-control-solid w-sm-350px ps-14'
                    placeholder='Search'
                    value={searchTerm}
                    onChange={HandleChange}
                />
            </div>
            {isDashboard && (
                <button
                    type='button'
                    className='btn btn-light-primary me-3'
                    onClick={() => navigate(-1)}
                >
                    <KTIcon iconName='arrow-left' className='fs-2' />
                    Back
                </button>
            )}
        </div>
    )
}

export { ProductsListSearchComponent }
